import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseController } from '../../base.controller';
import { MapsAddressCacheItemDto } from './MapsAddressCacheItemDto';
import { MapsAddressCachePageDto } from './MapsAddressCachePageDto';
import { MapsAddressCacheSearchDto } from './MapsAddressCacheSearchDto';

/***
 * Manteniment intern de la caché global de geocodificacions (MAPS_ADDRESS_CACHE).
 *
 * Taula molt gran: només cerca paginada a servidor. La clau (requestedAddress) pot
 * contenir '/', espais i comes, per tant sempre viatja al body, mai a la URL.
 */
@Injectable()
export class MapsAddressCacheAdminController extends BaseController {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router);
    }

    private baseUrl(): string {
        return '/internal/mapsaddresscache';
    }

    public searchPaged(search: MapsAddressCacheSearchDto): Observable<MapsAddressCachePageDto> {
        return this.post(this.baseUrl() + '/search-paged', search, 'MapsAddressCacheAdminController.searchPaged');
    }

    public detail(requestedAddress: string): Observable<MapsAddressCacheItemDto> {
        return this.post(this.baseUrl() + '/detail', { requestedAddress: requestedAddress },
            'MapsAddressCacheAdminController.detail');
    }

    public create(item: MapsAddressCacheItemDto): Observable<MapsAddressCacheItemDto> {
        return this.post(this.baseUrl() + '/', item, 'MapsAddressCacheAdminController.create');
    }

    public update(item: MapsAddressCacheItemDto): Observable<MapsAddressCacheItemDto> {
        return this.put(this.baseUrl() + '/', item, 'MapsAddressCacheAdminController.update');
    }

    public deleteByKey(requestedAddress: string): Observable<boolean> {
        return this.post(this.baseUrl() + '/delete', { requestedAddress: requestedAddress },
            'MapsAddressCacheAdminController.delete');
    }
}
